// Serialize score writes and coalesce rapid taps, so older requests cannot
// overwrite newer scores. Failed writes keep the desired score for retry.
export function createLiveScore({ initial, write, onSaved = () => {} }) {
  let confirmed = { ...initial };
  let desired = { ...initial };
  let saving = false;
  let error = null;
  let snapshot;
  const listeners = new Set();
  const equal = (a, b) => a.score_a === b.score_a && a.score_b === b.score_b;
  const publish = () => {
    snapshot = { ...desired, saving, error, unsaved: !equal(desired, confirmed) };
    listeners.forEach((listener) => listener());
  };
  publish();

  const flush = async () => {
    if (saving || (!error && equal(desired, confirmed))) return;
    let forceWrite = !!error;
    saving = true;
    error = null;
    publish();
    let result;
    try {
      while (forceWrite || !equal(desired, confirmed)) {
        forceWrite = false;
        const sending = { ...desired };
        result = await write(sending);
        confirmed = sending;
      }
      onSaved(result);
    } catch (failure) {
      error = failure;
    } finally {
      saving = false;
      publish();
    }
  };

  return {
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
    getSnapshot: () => snapshot,
    change(side, delta) {
      desired = { ...desired, [side]: Math.max(0, desired[side] + delta) };
      publish();
      return flush();
    },
    retry: flush,
    acceptRemote(scores) {
      if (saving || error || !equal(desired, confirmed) || equal(desired, scores)) return;
      confirmed = { ...scores };
      desired = { ...scores };
      publish();
    },
  };
}
